<template>
  <div>
    <div v-for="game in eventCompitions" :key="game.name" class="list-event">
      <v-list-item
        :id="game.name"
        :key="game.name"
        dense
        active-class="primary"
        :to="`/sportsbook/${$route.params.category}/${$route.params.subCategory}/${game._id}`"
      >
        <v-list-item-content @click="getEventCompetion()">
          <v-list-item-title>
            {{ game.name }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- <v-divider :key="'divider' + game.name"></v-divider> -->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SportbookCategory',
  props: {
    eventCompitions: { type: Array, default: () => [], required: true },
    orientation: { type: String, default: 'horizontal' }
  },
  data() {
    return {
      model: null,
      scrollClass: 'left-main'
    }
  },
  computed: {
    gameName() {
      return this.$route.params.category
    },
    eventGameData() {
      return this.$route.params.subCategory
    },
    ...mapState({
      loading: (state) => state.sportsbookCategory.loading
      // eventCompitions: (state) => state.sportsbookCategory.eventCompetionData
    })
  },
  // async created() {
  //   try {
  //     if (this.$route.params.category && this.$route.params.subCategory) {
  //       this.scrollClass = 'left-main-subcategory'
  //       await this.$store.dispatch(
  //         'sportsbookCategory/getEventCompetition',
  //         this.$route.params.subCategory
  //       )
  //     } else {
  //     }
  //   } catch (error) {}
  // },

  // beforeDestroy() {
  //   this.$store.commit('sportsbookCategory/empty_data')
  // },

  methods: {
    getEventCompetion() {
      this.$store.dispatch(
        'sportsbookCategory/getEventCompetition',
        this.$route.params.subCategory
      )
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped>
.theme--dark.v-list-item--active:hover::before,
.theme--dark.v-list-item--active::before {
  opacity: 0.1;
}
</style>
